import * as React from 'react';
import {connect} from 'react-redux';
import {IVendors} from "./business-objects/common";
import {Col, Container, Form, Row} from 'react-bootstrap';
import * as _ from 'lodash';


interface IVendorEditFormOwnProps {
    vendorToEdit: IVendors;
}

interface IVendorEditFormLocalState {
    currentVendor: IVendors;
}

export class VendorEditForm extends React.Component <IVendorEditFormOwnProps, IVendorEditFormLocalState> {

    constructor(props) {
        super(props);
        this.state = {
            currentVendor: {} as IVendors
        };
    }

    componentWillMount() {
        this.setState(
            {
                currentVendor: {..._.cloneDeep(this.props.vendorToEdit)}
            },
            () => {
                this.setState({
                    currentVendor: this.state.currentVendor
                });
            }
        );
    }

    getUpdatedVendor = () => this.state.currentVendor;

    handleVendorChange = (e: React.FormEvent) => {
        let el: HTMLFormElement = e.currentTarget as HTMLFormElement;

        switch (el.dataset.field) {
            case 'Vendor Name':
                this.setState({
                    currentVendor: { ...this.state.currentVendor, name: el.value }
                });
                break;
            case 'Description':
                this.setState({
                    currentVendor: { ...this.state.currentVendor, description: el.value }
                });
                break;
            case 'Vendor Key Id':
                this.setState({
                    currentVendor: { ...this.state.currentVendor, vendorKeyId: el.value }
                });
                break;
            default:
                break;
        }
    };
    private vendorName: any;
    private description: any;
    private vendorKeyId: any;

    render() {
        return (
            <Container>
                <Row className="flex-nowrap">
                    <Col xs={9}>
                        <Form>
                            <Form.Group controlId="vendorName">
                                <Form.Label column={this.vendorName}>
                                    <strong>Vendor Name</strong>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    data-field="Vendor Name"
                                    placeholder="Enter Vendor Name..."
                                    onChange={this.handleVendorChange}
                                    value={this.state.currentVendor.name}
                                />
                            </Form.Group>

                            <Form.Group controlId="description">
                                <Form.Label column={this.description}>
                                    <strong>Description</strong>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    data-field="Description"
                                    placeholder="Enter Description..."
                                    onChange={this.handleVendorChange}
                                    value={this.state.currentVendor.description}
                                />
                            </Form.Group>

                            <Form.Group controlId="vendorKeyId">
                                <Form.Label column={this.vendorKeyId}>
                                    <strong>Vendor Key Id</strong>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    data-field="Vendor Key Id"
                                    placeholder="Enter Vendor Key Id..."
                                    onChange={this.handleVendorChange}
                                    value={this.state.currentVendor.vendorKeyId}
                                />
                            </Form.Group>
                        </Form>
                    </Col>
                </Row>
            </Container>
        );
    }
}

const mapDispatchToProps = {};

const mapStateToProps = (reduxState: any) => {
    return {
        appUrl: reduxState.Application.backendURL,
        //formIOUrl: reduxState.Application.formIOUrl
    };
};

export default connect<any>(mapStateToProps, mapDispatchToProps,
    null,
    { forwardRef: true })(VendorEditForm);
